import React from 'react';
export interface IChannelsProps {
  channelLogos: string[];
}

export const Channels = ({ channelLogos }: IChannelsProps) => {
  return (
    <div className="flex flex-row items-center col-gap-5 row-gap-12 flex-wrap sm:overflow-hidden">
      {channelLogos?.map(channelLogo => (
        <div className="w-18 h-18 p-1" key={channelLogo}>
          <img className="w-full h-full object-contain" src={channelLogo} alt="" />
        </div>
      ))}
    </div>
  );
};
